"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'botTest.tester.name': 'Tester Name',
    'botTest.tester.model': 'AI Model',
};
